import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-note-sign',
  templateUrl: './note-sign.component.html'
})
export class NoteSignComponent {}
